import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const PrivacyPage = () => (
  <Layout>
    <SEO title="Privacy Policy" />
    <h1>Privacy Policy</h1>
    <p>
      We do not store any personal data what-so-ever. We don't even ask for
      personal data!
    </p>
    <p>
      <Link to="/">&lt; Home</Link>
    </p>
  </Layout>
)

export default PrivacyPage
